import { UIActionType, UIAction } from '../../actions/uiActions';

const slackDialogReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_SLACK_DIALOG:
      return !state;
    default:
      return state;
  }
};

export default slackDialogReducer;
